import { Controller } from '@hotwired/stimulus';
import { WidgetManager } from '@infakt/widgets/vanilla-sdk';

import { trackError } from '../shared/lib/errorTracking';

export default class extends Controller {
  static values = {
    containerId: String,
  };

  async connect() {
    const connectionToken = {};
    this.connectionToken = connectionToken;

    try {
      const manager = new WidgetManager();
      const widget = await manager.init({
        name: 'session-extend',
        containerId: this.containerIdValue,
        onError: (error) => {
          trackError(
            error instanceof Error ? error : new Error(String(error ?? 'Unknown widget error')),
            { context: 'session_extend_widget' },
            { errorMessage: error?.message },
          );
        },
      });

      if (this.connectionToken !== connectionToken) return;

      this.manager = manager;
      this.widget = widget;

      await widget.mount();

      if (this.connectionToken !== connectionToken) {
        widget.unmount();
        return;
      }
    } catch (error) {
      console.error('[session-extend-widget]', error);
    }
  }

  disconnect() {
    this.connectionToken = null;
    this.widget?.unmount();
    this.widget = undefined;
  }
}
